import React, { Component} from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('inventoryProductStore', 'inventoryPcategoryStore', 'inventoryManufacturerStore', 'inventorySupplierStore')
@observer
class ProductEdit extends Component {
  render() {
    const { inventoryProductStore, inventoryPcategoryStore, inventoryManufacturerStore, inventorySupplierStore, params } = this.props;

    return (
      <ItemModify
      title='Product'
      slug = '/inventory/product'
      store = {inventoryProductStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Code', key: 'code', type: 'text' },
        { label: 'Product Category', key: 'pcategory_id', type: 'select', options: inventoryPcategoryStore.items.toJS(),  fields:{label: 'name', value: 'id'}  },
        { label: 'Supplier', key: 'supplier_id', type: 'select', options: inventorySupplierStore.items.toJS(),  fields:{label: 'name', value: 'id'}  },
        { label: 'Manufacturer', key: 'manufacturer_id', type: 'select', options: inventoryManufacturerStore.items.toJS(),  fields:{label: 'name', value: 'id'}  },
      ]}
      params={params}
      />
    );
  }
}

export default ProductEdit;



// WEBPACK FOOTER //
// ./src/components/Inventory/ProductModify.js